import { useQuery } from "@tanstack/react-query";
import API from "@/api";

function useObservationStats(nurseryId: string, interval: "day"|"week"|"month" = "day", queryParams?: URLSearchParams) {
  const { isPending, error, data } = useQuery({
    queryKey: ["observation-stats", nurseryId, interval, queryParams?.toString()],
    queryFn: () => API.getObservationStats(nurseryId, interval, queryParams)
  });

  return {
    isPending,
    error,
    data
  };
}

export default useObservationStats;
